import { useLocalLogic } from "~/context/clientProvider";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { type Location } from "~/types/sdks";
import { locationsResponse, locationsKeys } from "~/features/locations";

export function useLocation({ lat, lng }: Location) {
  const { client } = useLocalLogic();
  const options: locationsResponse = {
    lat: lat || NaN,
    lng: lng || NaN,
  };

  const { isLoading, data } = useQuery({
    queryKey: locationsKeys.list(options),
    queryFn: async () =>
      client.getLocation(options as unknown as locationsResponse),
    enabled: !!options,
  });

  const country = useMemo(() => {
    if (data?.country?.toLowerCase() === "united states") {
      return "USA";
    }

    return "CAN";
  }, [data]);

  return { isLoading, data: { country } };
}
